module.exports = __webpack_public_path__ + "static/media/PlanoConta2.c1e2420a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/CadPlanoConta/PlanoConta2.png
// module id = 2202
// module chunks = 0